module.exports = __webpack_public_path__ + "img/ic_video-on.c3caf780.svg";